import { find } from "lodash";
import { getPrettyDate } from '../../common/utils/date-utils';

export const formatActionLogFormValues = (actionLog) => { 

    let logs = [];
    let existingLog;
    let filteredLogs = actionLog.slice(0,5);

    for (let i = 0; i < filteredLogs.length; i++) {
        existingLog = find(logs, { actionDate: getPrettyDate(filteredLogs[i].actionDate) });

        if(existingLog === undefined) {
            logs.push({
                actionDate: getPrettyDate(filteredLogs[i].actionDate),
                entries: [{
                    message: filteredLogs[i].message,
                    type: filteredLogs[i].type
                }]
            });
        }
        else {
            for (let j = 0; j < logs.length; j++) {
                if(getPrettyDate(logs[j].actionDate) === getPrettyDate(existingLog.actionDate)) {
                    logs[j].entries.push({
                        message: filteredLogs[i].message,
                        type: filteredLogs[i].type
                    });
                }
            }
        }
    }
    
    return logs;
}